module.exports = __webpack_public_path__ + "static/media/gama.2e467d8d.svg";